module.exports = __webpack_public_path__ + "media/Note.b4ac072f.mp3";